import { Check } from 'lucide-react';
import { Label } from '@/components/ui/label';
import { useStrategyIcons } from '@/hooks/useStrategies';
import type { StrategyIcon } from '@/types/strategy';

interface StrategyIconSelectProps {
  value: number | null;
  onChange: (iconDocumentId: number | null) => void;
}

export default function StrategyIconSelect({ value, onChange }: StrategyIconSelectProps) {
  
  const { data: icons, isLoading } = useStrategyIcons();

  if (isLoading) {
    return (
      <div className="space-y-2">
        <Label>Strategy Icon</Label>
        <div className="text-sm text-pine-ink-soft">Loading icons...</div>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <Label>Strategy Icon</Label>
        {value && (
          <button
            type="button"
            onClick={() => onChange(null)}
            className="text-xs text-pine-ink-soft hover:text-pine-ink transition-colors"
          >
            Clear
          </button>
        )}
      </div>
      <div className="grid grid-cols-5 gap-2">
        {icons?.map((icon: StrategyIcon) => {
          const docId = parseInt(icon.documentId, 10);
          const isSelected = value === docId;
          return (
            <button
              key={icon.id}
              type="button"
              onClick={() => onChange(isSelected ? null : docId)}
              className={`
                relative flex flex-col items-center gap-1 p-2 rounded-lg border transition-colors
                ${isSelected
                  ? 'border-pine-pine bg-pine-active-item'
                  : 'border-pine-line hover:border-pine-pine/40 bg-pine-l2'
                }
              `}
            >
              {icon.imageUrl && (
                <img
                  src={icon.imageUrl}
                  alt={icon.label}
                  className="w-10 h-10 object-contain"
                />
              )}
              <span className="text-xs text-pine-ink-soft truncate w-full text-center">
                {icon.label.replace('.svg', '')}
              </span>
              {isSelected && (
                <div className="absolute top-1 right-1">
                  <Check className="w-3 h-3 text-pine-pine" />
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
